// extracted by mini-css-extract-plugin
module.exports = {"root":"root__Dg_lx","link":"link__1dVzd","subtitle":"subtitle__ZLnpR","clipped":"clipped__1I-gk"};